import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.boundScrollToFrame = this.scrollToFrame.bind(this)
    this.boundClearOnCalendarNav = this.clearOnCalendarNav.bind(this)

    const bookingFrame = document.getElementById("booking_confirmation_frame")
    const calendarFrame = document.getElementById("calendar_frame")

    if (bookingFrame) {
      bookingFrame.addEventListener("turbo:frame-load", this.boundScrollToFrame)
    }
    if (calendarFrame) {
      calendarFrame.addEventListener("turbo:frame-load", this.boundClearOnCalendarNav)
    }
  }

  disconnect() {
    const bookingFrame = document.getElementById("booking_confirmation_frame")
    const calendarFrame = document.getElementById("calendar_frame")

    if (bookingFrame) {
      bookingFrame.removeEventListener("turbo:frame-load", this.boundScrollToFrame)
    }
    if (calendarFrame) {
      calendarFrame.removeEventListener("turbo:frame-load", this.boundClearOnCalendarNav)
    }
  }

  highlight(event) {
    this.element.querySelectorAll(".time-slot.selected").forEach((el) => {
      el.classList.remove("selected")
    })
    event.currentTarget.classList.add("selected")
  }

  clearSelection() {
    this.element.querySelectorAll(".time-slot.selected").forEach((el) => {
      el.classList.remove("selected")
    })
  }

  scrollToFrame() {
    const frame = document.getElementById("booking_confirmation_frame")
    if (frame && frame.innerHTML.trim() !== "") {
      frame.scrollIntoView({ behavior: "smooth" })
    }
  }

  clearOnCalendarNav() {
    const bookingFrame = document.getElementById("booking_confirmation_frame")
    if (bookingFrame) {
      bookingFrame.innerHTML = ""
    }
    this.clearSelection()
  }
}
